import { isEmpty } from 'lodash';

const populateFormFields = ({ setValue, selectedStudio }) => {
  const { room, name, address, latitude, longitude, rawData } = selectedStudio;

  if (!isEmpty(room)) setValue('room', room);
  if (!isEmpty(name)) setValue('name', name);
  if (address !== '-') setValue('address', address);
  if (!isEmpty(rawData?.appType)) setValue('appType', { label: rawData.appType.name, value: rawData.appType.id });
  if (!isEmpty(rawData?.area)) setValue('area', { label: rawData.area.name, value: rawData.area.id });
  if (latitude !== '-') setValue('latitude', latitude || '');
  if (longitude !== '-') setValue('longitude', longitude || '');
};

export default populateFormFields;
